import { Grid, TextField, TextFieldProps } from '@freighthub/silhouette-core'
import { FC } from 'react'
import { useI18n } from 'utils/localisation'

import { IContact } from '../../domain/ShipmentInterface'

type Fields = Omit<IContact, '_id' | 'externalId' | 'pickupAddress' | 'contactID' | 'legalEntityID'>

type ContactCreateFieldsProps = {
  fields: Record<keyof Fields, TextFieldProps>
}

export const ContactCreateFields: FC<ContactCreateFieldsProps> = ({ fields }) => {
  const { translate } = useI18n()
  return (
    <>
      <Grid xs={12} sm={6}>
        <TextField
          label={translate('shipment_details-shipping_instructions-supplier_information-company_name')}
          name="companyName"
          fullWidth
          required
          {...fields.companyName}
        />
      </Grid>

      <Grid xs={12} sm={6}>
        <TextField
          label={translate('shipment_details-shipping_instructions-supplier_information-contact_person')}
          name="contactPerson"
          fullWidth
          required
          {...fields.contactPerson}
        />
      </Grid>

      <Grid xs={12}>
        <TextField
          label={translate('shipment_details-shipping_instructions-supplier_information-address')}
          name="address"
          fullWidth
          required
          {...fields.address}
        />
      </Grid>

      <Grid xs={12} sm={6}>
        <TextField
          label={translate('shipment_details-shipping_instructions-supplier_information-phone_number')}
          name="phone"
          fullWidth
          required
          {...fields.phone}
        />
      </Grid>

      <Grid xs={12} sm={6}>
        <TextField
          label={translate('shipment_details-shipping_instructions-supplier_information-email')}
          name="email"
          fullWidth
          required
          type="email"
          {...fields.email}
        />
      </Grid>
    </>
  )
}
